const toLang = (isSpanish) => (isSpanish ? 'es' : 'en');

/**
 * Resolve language ('es' | 'en') from a URL search string.
 * Falls back to sessionStorage when no URL signal is present.
 */
export const detectLangFromSearch = (search) => {
  const qs = search.startsWith('?') ? search.slice(1) : search;
  const params = new URLSearchParams(qs);

  const referrer = (params.get('referrer') || '').toLowerCase();
  if (referrer) {
    return toLang(referrer.endsWith('.es'));
  }

  return toLang(sessionStorage.getItem('elnk_lang') === 'es');
};

/**
 * Resolve language from window.location.hash (for use outside React context).
 */
export const detectLangFromHash = () => {
  const hash = window.location.hash || '';
  const queryStr = hash.includes('?') ? hash.split('?')[1] : '';
  return detectLangFromSearch(queryStr);
};

/**
* Record that the user explicitly picked a language (header toggle, checkout
* dropdown) so URL/referrer-based detection on a later remount doesn't stomp it.
*/
export const setManualLangPreference = (isSpanish) => {
  sessionStorage.setItem('elnk_lang', toLang(isSpanish));
  sessionStorage.setItem('elnk_lang_manual', 'true');
};

export const hasManualLangPreference = () => sessionStorage.getItem('elnk_lang_manual') === 'true';
